module.exports = __webpack_public_path__ + "img/main-slide-img1.3ede7c32.png";